import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import Button from '@material-ui/core/Button'
import InputBase from '@material-ui/core/InputBase';

class RestablecerContraseniaForm extends React.Component {

    componentWillUnmount = () => {
        // limpio el mensaje de error
        this.props.limpiarDatos()
    }

    render() {
        return (
            <div className='restablecerContraseniaForm'>
                <div className='container'>

                <div className='logoContainer center'>
                       <img src={require('../../images/logoLogin.png')} alt=""/>
                        </div>

                    <div className='inputContainer'>
                        <InputBase
                            placeholder="Escribe la nueva contraseña"
                            value={this.props.loginData.nuevaContrasenia}
                            type="password"
                            name="nuevaContrasenia"
                            onChange={this.props.handleOnDataChange}
                            error={this.props.errores.nuevaContrasenia !== undefined}
                        />
                        {this.props.errores.nuevaContrasenia !== undefined && 
                        <FormHelperText error>{this.props.errores.nuevaContrasenia}</FormHelperText>}
                    </div>

                    <div className='inputContainer'>
                        <InputBase
                            placeholder="Reescribe la nueva contraseña"
                            value={this.props.loginData.repeticionNuevaContrasenia}
                            type="password"
                            name="repeticionNuevaContrasenia"
                            onChange={this.props.handleOnDataChange}
                            error={this.props.errores.repeticionNuevaContrasenia !== undefined}
                        />
                        {this.props.errores.repeticionNuevaContrasenia !== undefined && 
                        <FormHelperText error>{this.props.errores.repeticionNuevaContrasenia}</FormHelperText>}
                    </div>

                    <div className='myLabel error' style={{ visibility: this.props.errorAutenticacion ? 'visible' : 'hidden' }} >{this.props.errorAutenticacion || ''}</div>

                    <div className='buttonContainer'>
                        {/*<Button className='btnSecundario' onClick={this.props.handleOnCancelar}>CANCELAR</Button>*/}
                        <Button className='btnPrincipal' onClick={this.props.handleOnRestablecerContrasenia}>RESTABLECER</Button>
                    </div>
                </div>
            </div>
        )
    }
}

RestablecerContraseniaForm.propTypes = {
    loginData: PropTypes.object.isRequired,
    errores: PropTypes.object.isRequired,
    handleOnDataChange: PropTypes.func.isRequired,
    handleOnRestablecerContrasenia: PropTypes.func.isRequired,
    handleOnCancelar: PropTypes.func.isRequired,
    errorAutenticacion: PropTypes.string,
    limpiarDatos: PropTypes.func.isRequired,
}

export default RestablecerContraseniaForm